/**
 * DsHero — Componente hero reutilizable del Design System.
 *
 * Props:
 *  icon       Lucide icon component (e.g. Receipt, FileText)
 *  eyebrow    Texto chico arriba del título ("RRHH · Solicitudes")
 *  title      Título principal (string o ReactNode)
 *  subtitle   Descripción debajo del título
 *  accent     Color de acento hex ("#005EAE")
 *  accentBg   Color de fondo del icono ("#EBF0FA")
 *  children   Contenido del área de acciones (botones, selects, etc.)
 */
const DsHero = ({ icon: Icon, eyebrow, title, subtitle, accent, accentBg, className, style, children }) => {
  const heroStyle = { ...style };
  if (accent) heroStyle["--ds-accent"] = accent;
  if (accentBg) heroStyle["--ds-accent-bg"] = accentBg;

  return (
    <div
      className={`ds-hero${className ? ` ${className}` : ''}`}
      style={Object.keys(heroStyle).length ? heroStyle : undefined}
    >
      <div>
        {eyebrow && <span className="ds-hero__eyebrow">{eyebrow}</span>}
        <div className="ds-hero__row">
          {Icon && (
            <div className="ds-hero__icon">
              <Icon size={22} />
            </div>
          )}
          <div>
            <h1>{title}</h1>
            {subtitle && <p>{subtitle}</p>}
          </div>
        </div>
      </div>
      {children && <div className="ds-hero__actions">{children}</div>}
    </div>
  );
};

export default DsHero;
